import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router';
import { Link, useLocation } from "react-router-dom";
import i18n from "../../il8n/il8n";
import { setActive } from "../../redux/routerSlice";

const routeList = [{
    id: 1,
    route: '/kyc/person',
    icon: 'pi-user',
    text: 'Personal details',
    type: 'I'
}, {
    id: 2,
    route: '/kyc/company',
    icon: 'pi-th-large',
    text: 'Company details',
    type: 'C'
}, {
    id: 3,
    route: '/kyc/boid',
    icon: 'pi-chart-bar',
    text: 'BOID details'
}, {
    id: 4,
    route: '/kyc/address',
    icon: 'pi-map-marker',
    text: 'Address details'
}, {
    id: 5,
    route: '/kyc/director',
    icon: 'pi-users',
    text: 'Director details',
    type: 'C'
}, {
    id: 6,
    route: '/kyc/family',
    icon: 'pi-users',
    text: 'Family details',
    type: 'I'
}, {
    id: 7,
    route: '/kyc/bank',
    icon: 'pi-credit-card',
    text: 'Bank details'
}, {
    id: 8,
    route: '/kyc/occupation',
    icon: 'pi-briefcase',
    text: 'Occupation details',
    type: 'I'
}, {
    id: 9,
    route: '/kyc/guardian',
    icon: 'pi-shield',
    text: 'Guardian details',
    type: 'I'
}, {
    id: 10,
    route: '/kyc/document',
    icon: 'pi-file',
    text: 'Document details'
}, {
    id: 13,
    route: "/kyc/biometrics",
    icon: "pi-check-square",
    text: "Biometrics",
}, {
    id: 12,
    route: '/kyc/decleration',
    icon: 'pi-check-square',
    text: 'Declaration'
}];

export function NextButton() {
    const activeSectionId = useSelector(state => state.routerData.activeSectionId);
    const formType = useSelector(state => state.routerData.formType);
    const history = useHistory();

    return (<Button
        className="pull-right"
        label="Next"
        onClick={event => nextTab(activeSectionId, formType, history)} />);
}

export function PrevButton() {
    const activeSectionId = useSelector(state => state.routerData.activeSectionId);
    const formType = useSelector(state => state.routerData.formType);
    const history = useHistory();

    return (<Button className="p-button-text" label="Back"
        onClick={event => prevTab(activeSectionId, formType, history)} />);
}

export function nextTab(id, formType, history) {
    console.log(id, formType, history);
    let flag;
    for (let route of routeList) {
        if (id === route.id) {
            flag = true;
        } else if (flag && (!route.type || route.type === formType)) {
            history.push(route.route);
            break;
        }
    }
}

export function prevTab(id, formType, history) {
    let proute;
    for (let route of routeList) {
        if (id === route.id) break;
        else if (!route.type || route.type === formType) proute = route;
    }

    if (proute)
        history.push(proute.route);
}

const url = ''

const DashboardKycSideBar = ({ match, router }) => {
    const location = useLocation();
    return (
        <div id="kycProgressBar" className="p-col-12 p-md-3">
            <div className="sidebar-logo" style={{ marginTop: '70%', width: 400, display: 'flex', alignContent: 'center', justifyContent: 'center', placeContent: 'center', flexDirection: 'column' }}>
                <img src='/cdsc-white-Logo.png' style={{ width: 100, placeSelf: 'center', marginBottom: 20 }} />
                <div style={{
                    fontSize: 30, textAlign: 'center', color: '#fff'
                }} >Centralized <br /> KYC</div>
            </div>
            <div className="sidebar-copyright">
                {/* Powered By PCS */}
                <LanguageBar />
            </div>
        </div >);
};

const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
}

const LanguageBar = () => {
    return (<div>
        <a className="lang-link-button" href="#" onClick={() => changeLanguage('np')}>Nepali</a> | <a className="lang-link-button" href="#" onClick={() => changeLanguage('en')}>English</a>
    </div>);
}

export default DashboardKycSideBar;